import { ListModel } from '@shared/models/list.model';
import { Utilities as U } from '@shared/utilities/utilities.model';
import { DossierWorking } from '@authority/authority-shared/models/dossier-working.model';

export class DossierWorkingListModel extends ListModel<DossierWorking> {

	constructor(model?: any) {
		super(model);
		this.items = [];
	
		if (U.isEmpty(model) || U.isEmpty(model.items)) {
			return;
		}

		this.items = model.items.map(x => new DossierWorking(x));
	}
}
